import { DataSource, InteractiveCell, ReadyOnlyCell } from '../types';
import { MatrixIcons } from './matrix.component';
import { MatrixType } from './matrix.module';

export function filterDataSource(matrixType: MatrixType, dataSource: DataSource) {
    const isPrepackCell = (cell: InteractiveCell | ReadyOnlyCell) =>
        'items' in cell && cell.topLabel !== MatrixIcons.Shop;

    if (dataSource) {
        if (matrixType === MatrixType.Prepacks) {
            return dataSource.filter((row) => row.some((cell) => !cell || isPrepackCell(cell)));
        } else if ([MatrixType.Compound, MatrixType.SingleSize].includes(matrixType)) {
            return dataSource.filter((row) => row.every((cell) => !cell || !isPrepackCell(cell)));
        } else {
            return dataSource;
        }
    }

    return dataSource;
}
